<template>
  <div>
    <template v-for="(d, e) in entries">
      <router-link :key="e"
                   v-if="!d.hidden"
                   :to="{ name: e }"
                   :class="{ active: isactive(e) }" 
                   @click.native="$emit('click')"
                   class="item">
        <i :class="d.icon" class="icon"></i>
        {{ d.text }}
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageLinks',
  props: [],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
    entries() {
      return {
        //dashboard: "Dashboard",
        files: {
          text: "我的网盘",
          icon: ['home'],
        },
        favs: {
          text: "收藏夹",
          icon: ['star'],
        },
        recents: {
          text: "最近使用",
          icon: ['dove'],
          hidden: true,
        },
        photos: {
          text: "图片和视频",
          icon: ['photo', 'video'],
          hidden: true,
        },
        shares: {
          text: "共享内容",
          icon: ['share', 'alternate'],
          hidden: true,
        },
        ingress: {
          text: "文件闪传",
          icon: ['bolt'],
        },
        passwords: {
          text: "密码管理器",
          icon: ['shield', 'alternate'],
        },
        notes: {
          text: "速记本",
          icon: ['feather', 'alternate'],
        },
        history: {
          text: "历史版本",
          icon: ['history'],
        },
        settings: {
          text: "设置",
          icon: ['wrench'],
        },
      };
    },
  },
  methods: {
    isactive(e) {
      return (e == this.$route.name);
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
#sidebar .item:before {
  display: none;
}

.sidebar i {
  float: none !important;
  margin-right: 0.5rem !important;
}

#sidebar .active {
  border-left-width: 0;
  border-top-width: 0;
  border-bottom-width: 0;
  border-right-width: 3px;
  border-color: #4c5c68;
  border-style: solid;
  font-weight: bold;
}
</style>

